import './sidenav.scss';
import { Dispatch, SetStateAction, useCallback, useEffect, useRef, useState } from 'react';
import SideNavItem from './sidenav-item';
import { useDispatch, useSelector } from 'react-redux';
import { ProductType, RootState } from 'types';
import { useHistory, useParams } from 'react-router';
import api from 'api';
import { actions } from 'redux/reducers';
import ReportModal from 'components/app/report/report-modal';
import ProductDetailsModal from './product-details-modal';
import NotificationManagementModal from './notification-management-modal';
import { useSidenavContent } from 'hooks/sidenav-content';
import FPQueryModal from 'components/app/report/narrative-analysis/fp-query-modal';

function SideNav({
    open, setOpen
} : {
    open: boolean,
    setOpen: Dispatch<SetStateAction<boolean>>
}) {
    const params: any = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const ref = useRef<any>();
    const state = useSelector((state: RootState) => state);
    const [product, setProduct] = useState<any>({ name: '', description: '', price: '' });
    const [active, setActive] = useState<any>(null);
    const [tutorials, setTutorials]  = useState<any>(null);
    const [currentPlatformId, setPlatformId]  = useState<any>(null);
    const [reportModalOpen, setReportModalOpen] = useState<boolean>(false);
    const [fpQueryModalOpen, setFpQueryModalOpen] = useState<boolean>(false);
    const [productDetailsModalOpen, setProductDetailsModalOpen] = useState<boolean>(false);
    const [notificationManagementModalOpen, setNotificationManagementModalOpen] = useState<boolean>(false);

    const content = useSidenavContent();

    const expand = (ref: any) => {
        if (ref === active) {
            setActive(null);
        } else {
            setActive(ref);
        }
    }

    const handleClick = (item: any, ref?: any) => {
        if (item.disabled) {
            setProduct({
                name: item.name,
                description: item.description,
                price: item.price
            })
            setOpen(false);
            setProductDetailsModalOpen(true);
        } else {
            switch (item.onClick.type) {
                case "expand":
                    expand(ref);
                    return;
                case "navigate":
                    setOpen(false);
                    setActive(null);
                    history.push(item.onClick.params);
                    return;
                case "callback":
                    setActive(null);
                    setOpen(false);
                    eval(item.onClick.params);
                    return;
            }
        }
    }

    const getMentorPlatforms = useCallback(async () => {
        const data = await api.mentor.getPlatforms();
        setPlatformId(data.filter((x: { name: string; }) => x.name === "amaSocial")[0].id)

        if (currentPlatformId !== null && currentPlatformId !== undefined){
            api.mentor.getAllTutorials(currentPlatformId).then(setTutorials);
        }
    }, [currentPlatformId])

    // useEffect(() => {
    //     getMentorPlatforms();
    // }, [getMentorPlatforms]);

    useEffect(() => {
        if (params.projectId && !state.project) {
            api.project.get(params.projectId).then(data => {
                dispatch(actions.project.set(data));
            })
        }
    }, [params.projectId, state.project, dispatch])

    useEffect(() => {
        function handleClick(e: any) {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        }
        
        document.addEventListener('click', e => handleClick(e));
        return () => document.removeEventListener('click', handleClick);
    }, [setOpen])

    return (
        <>
            <div id="sidenav" className={`${open ? 'open' : ''}`} ref={ref}>
                <p className="heading">{state.project?.ProjectType}</p>
                <p className="project-name" onClick={() => history.replace(`/client/${params.clientId}/projects`)}>{state.project?.Description}</p>
                {content.map((x: any, i: number) => {
                    return (
                        <SideNavItem 
                            key={i}
                            item={x}
                            onClick={handleClick}
                            active={active}
                        />
                    )
                })}
            </div>
            <ProductDetailsModal 
                open={productDetailsModalOpen} 
                setOpen={setProductDetailsModalOpen} 
                name={product.name}
                description={product.description}
                price={product.price}
            />
            <NotificationManagementModal open={notificationManagementModalOpen} setOpen={setNotificationManagementModalOpen} />
            <ReportModal open={reportModalOpen} setOpen={setReportModalOpen} />
            <FPQueryModal open={fpQueryModalOpen} setOpen={setFpQueryModalOpen} />
        </>

    )
}

export default SideNav;